export const MODULE_ROUTE = {
  LOGIN: "/login-page",
  DASHBOARD: "/",
  SETTING: "/setting",
  PARENT_MODULE: "/parent-module",
  CHILDREN_1: "/children-1",
  CHILDREN_2: "/children-2",
  SERVICE_TYPE_LIST: "/service-types",
  SERVICES_LIST: "/services",
  SERVICE_MAP_LIST: "/service-type-maps",
  SERVICE_ADDON_LIST: "/service-addons",
  POS_ORDER: "/pos-order",
  CREATE_ORDER: "/create-order",
  ORDER: "/order",
  BRANCH: "/branch",
  TRANSPORT_VEHICLE: "/transport-vehicle",
  USER: "/user",
  DEPARTMENT: "/department",
  PROFILE: "/profile",
  CUSTOMER: "/customer",
  DRIVER: "/driver",

  PERMISSION_EMPLOYEE: "/permission-employee",
  PERMISSION_DEPARTMENT: "/permission-department",

  PRIVILEGE: "/privileges",
  RECEIPT_CATEGORY : "/receipt-categories",
  RECEIPT: "/receipt",
  ACCOUNTING_ACCOUNT:"/accounting-account",

  CHANGE_PASSWORD: "/change-password",
  SHIFT: "/shift",
  SHIFT_ASSIGNMENT: "/shift-assignment",
  ATTENDANCE_RECORD: "/attendance-record",
  SETTING_PAYMENT_METHOD: "/setting-payment-method",
  SETTING_DRIVER: "/setting-driver",
  ATTENDANCE_MANAGEMENT: "/attendance-management",
  ATTENDANCE_PERSONAL: "/attendance-personal",

  // Reports
  REPORT_EXECUTIVE: "/reports/executive",
  REPORT_SALES: "/reports/sales",
  REPORT_OPERATIONS: "/reports/operations",
  REPORT_FINANCE: "/reports/finance",
  REPORT_MARKETING: "/reports/marketing",
  EMPLOYEE_KG_REPORT: "/reports/employee-kg",
  FAULT_TICKET_REPORT: "/reports/fault-ticket",
  RECONCILIATION_REPORT: "/reports/reconciliation",
  ITEM_DEBT_OVERVIEW_REPORT: "/reports/item-debt-overview",
  REWASH_REPORT: "/reports/rewash",
  SALES_OUTPUT_REPORT: "/reports/sales-output",

  // Equipment & Branch Settings
  EQUIPMENT: "/equipment",
  BRANCH_SETTINGS: "/branch-settings",
  CLOTHING_CATEGORIES: "/clothing-categories",
  UNITS: "/units",

  // New features
  CUSTOMER_PRICING: "/customer-pricing",
  WAGE_RATES: "/wage-rates",
  DRIVER_CASH_LEDGER: "/driver-cash-ledger",
  CASH_LEDGER_REPORT: "/driver-cash-ledger/report",
  RECURRING_ORDERS: "/recurring-orders",
  CUSTOMER_DEBT: "/customer-debt",
  BANK_TRANSFER: "/bank-transfers",
  FAULT_TICKET: "/fault-tickets",
  ADJUSTMENT_REQUEST: "/adjustment-requests",
};
